export default __webpack_public_path__ + "static/media/Expand_Filters.7497f93c.svg";